const buildTicketStickerFromItem = (item) => {
  // this is from api
  return {
    id: item.id,
    title: item.title,
    slug: item.slug,
    campaignType: item.campaignType,
    causes: item.causes,
    confirmationEmail: item.confirmationEmail,
    cost: item.cost,
    description: item.description,
    donationMultiplier: item.donationMultiplier,
    endDate: item.endDate,
    eventDate: item.eventDate,
    glow: item.glow,
    hasOptions: item.hasOptions,
    impact: item.impact,
    isCausesSearchAllowed: item.isCausesSearchAllowed,
    isFeatured: item.isFeatured,
    location: item.location,
    maxDonation: item.maxDonation,
    maxQuantity: item.maxQuantity,
    quickCosts: item.quickCosts,
    reminderEmail: item.reminderEmail,
    startDate: item.startDate,
    tags: item.tags,
    url: item.url,
    varients: item.varients,
    waiverURL: item.waiverURL,
    bannerUrl: item.bannerUrl || null,
    locationType: item.locationType || null,
    virtualLink: item.virtualLink || null,
    hideLocation: item.hideLocation || false,
    addOns: item.addOns || [],
    gallery: item.gallery || [],
    faqs: item.faqs || [],
  }
}

const uploadDefaultStickerMap = (sticker) => {
  const quickCosts: number[] = [];
  const qc = sticker.quickCosts || [];
  qc.map((q) => {
    if (typeof q === 'number') {
      quickCosts.push(q);
    }
  })
  const updatedItem = {
    campaignType: null, // cause it's default sticker
    causes: sticker.causes || '',
    confirmationEmail: sticker.confirmationEmail || '',
    reminderEmail: sticker.reminderEmail || '',
    cost: parseFloat(parseFloat(sticker.cost).toFixed(2)),
    description: sticker.description || '',
    glow: sticker.glow,
    id: sticker.id || null,
    impact: sticker.impact || '',
    quickCosts: quickCosts,
    slug: sticker.slug || '',
    title: sticker.title || '',
    url: sticker.url || '',
    thumbnailUrl: sticker.thumbnailUrl || null,
    varients: [],
    hasOptions: sticker.hasOptions || null,
    isCausesSearchAllowed: sticker.isCausesSearchAllowed || false,
    isFeatured: false,
    waiverURL: '',
    donationMultiplier: 0,
    location: '',
    maxDonation: 0,
    maxQuantity: 0,
    tags: sticker.tags || '',
  };

  if (Array.isArray(sticker.tags)) {
    updatedItem.tags = sticker.tags.join(' |=| ');
  } else if (typeof sticker.tags === 'string') {
    updatedItem.tags = sticker.tags.split(',').join(' |=| ');
  }

  if (Array.isArray(sticker.causes)) {
    updatedItem.causes = sticker.causes.join(' |=| ');
  } else if (typeof sticker.causes === 'string') {
    updatedItem.causes = sticker.causes.split(',').join(' |=| ');
  } else {
    updatedItem.causes = '';
  }

  return updatedItem;
}

const stripTypename = ({ __typename, ...rest }) => rest;

const uploadTicketStickerMap = (sticker) => {
  let varients = sticker.varients || [];
  if (sticker.varients) {
    varients = varients.map((v) => {
      // Only send StickerVarientInput fields per the API spec.
      // Omitting legacy noise (stickerId, isActive, createdAt, updatedAt, __typename)
      // that is NOT part of the input type.
      const mapped = {
        id: v.id || null,
        title: v.title || '',
        cost: parseFloat(v.cost) || 0,
        isFree: v.isFree || false,
        whatsIncluded: v.whatsIncluded ?? null,
        selectionOptions: Array.isArray(v.selectionOptions) && v.selectionOptions.length > 0
          ? v.selectionOptions
          : null,
        isAddOn: v.isAddOn || false,
        quantity: v.quantity ?? null,
        sortOrder: v.sortOrder ?? 0,
      };
      console.log('[uploadTicketStickerMap] variant payload:', v.title,
        '| whatsIncluded:', JSON.stringify(mapped.whatsIncluded),
        '| selectionOptions:', JSON.stringify(mapped.selectionOptions));
      return mapped;
    });
  }

  let addOns = sticker.addOns || [];
  if (sticker.addOns) {
    addOns = addOns.map(stripTypename);
  }

  let gallery = sticker.gallery || [];
  if (sticker.gallery) {
    gallery = gallery.map(stripTypename);
  }

  let faqs = sticker.faqs || [];
  if (sticker.faqs) {
    faqs = faqs.map(stripTypename);
  }

  const updatedItem = {
    campaignType: 'Ticket',
    causes: sticker.causes || '',
    confirmationEmail: sticker.confirmationEmail || '',
    reminderEmail: sticker.reminderEmail || '',
    cost: parseFloat(parseFloat(sticker.cost).toFixed(2)),
    description: sticker.description || '',
    glow: sticker.glow,
    id: sticker.id || null,
    impact: sticker.impact || '',
    slug: sticker.slug || '',
    title: sticker.title || '',
    url: sticker.url || '',
    thumbnailUrl: sticker.thumbnailUrl || null,
    varients,
    addOns: addOns.length ? addOns : null,
    gallery: gallery.length ? gallery : null,
    faqs: faqs.length ? faqs : null,
    bannerUrl: sticker.bannerUrl || null,
    locationType: sticker.locationType || null,
    virtualLink: sticker.virtualLink || null,
    hideLocation: sticker.hideLocation || false,
    donationMultiplier: sticker.donationMultiplier || 0,
    endDate: sticker.endDate || null,
    startDate: sticker.startDate || null,
    eventDate: sticker.eventDate || null,
    hasOptions: sticker.hasOptions || null,
    isCausesSearchAllowed: sticker.isCausesSearchAllowed || false,
    isFeatured: sticker.isFeatured || false,
    location: sticker.location || '',
    maxDonation: sticker.maxDonation || 0,
    maxQuantity: sticker.maxQuantity || 0,
    waiverURL: sticker.waiverURL || '',
    startDateTimeZone: sticker.startDateTimeZone || null,
    endDateTimeZone: sticker.endDateTimeZone || null,
    eventDateTimeZone: sticker.eventDateTimeZone || null,
    tags: sticker.tags || '',
  };

  if (Array.isArray(sticker.tags)) {
    updatedItem.tags = sticker.tags.join(' |=| ');
  } else if (typeof sticker.tags === 'string') {
    updatedItem.tags = sticker.tags.split(',').join(' |=| ');
  }

  if (Array.isArray(sticker.causes)) {
    updatedItem.causes = sticker.causes.join(' |=| ');
  } else if (typeof sticker.causes === 'string') {
    updatedItem.causes = sticker.causes.split(',').join(' |=| ');
  } else {
    updatedItem.causes = '';
  }

  return updatedItem;
}

export { buildTicketStickerFromItem, uploadDefaultStickerMap, uploadTicketStickerMap }
